// Original: https://github.com/bvaughn/react-error-boundary
// Transformed to typescript here:
import * as React from "react";
import ErrorBoundaryFallbackComponent from "./ErrorBoundaryFallbackComponent";

interface Props {
    children?: any;
    FallbackComponent?: React.ComponentType<any>;
    onError?: (error: Error, componentStack: string) => void;
}

interface ErrorInfo {
    componentStack: string;
}

interface State {
    error?: Error;
    info?: ErrorInfo;
}

export class ErrorBoundary extends React.Component<Props, State> {
    public static defaultProps = {
        FallbackComponent: ErrorBoundaryFallbackComponent,
    };

    public constructor(props: any) {
        super(props);
        this.state = {
            error: undefined,
            info: undefined,
        };
    }

    public componentDidCatch(error: Error, info: ErrorInfo): void {
        const {onError} = this.props;

        if (typeof onError === "function") {
        try {
            onError.call(this, error, info ? info.componentStack : "");
        }
        catch (ignoredError) {}
        }

        this.setState({error, info});
    }

    public render() {
        const {children, FallbackComponent} = this.props;
        const {error, info} = this.state;

        if (error !== undefined) {
            console.warn("Error", error, info);

            if (FallbackComponent === undefined)
                return <div>ERROR: {info ? info.componentStack : ""}</div>;

            return (
                <FallbackComponent
                    componentStack={info ? info.componentStack : ""}
                    error={error}
                />
            );
        }

        return children;
    }
}

// export const withErrorBoundary = (
//   Component: React.ComponentType<any>,
//   FallbackComponent: React.ComponentType<any>,
//   onError: (error: Error, componentStack: string) => void,
// ): () => (props: any) => (
//     <ErrorBoundary FallbackComponent={FallbackComponent} onError={onError}>
//         <Component {...props} />
//     </ErrorBoundary>;
// )

export const withErrorBoundary = (
    Component: React.ComponentType<any>,
    FallbackComponent: React.ComponentType<any>,
    onError: (error: Error, componentStack: string) => void,
  ) => (props: any) => {
      return <ErrorBoundary FallbackComponent={FallbackComponent} onError={onError}>
          <Component {...props} />
      </ErrorBoundary>;
};



// WEBPACK FOOTER //
// ./src/components/error/ErrorBoundary.tsx